import * as React from 'react';
import { CardDatesCloseButtonHOC } from '../../../../../../aside_panel/cardDetails/DatesSection/hocs/CardDatesCloseButtonHOC/CardDatesCloseButtonHOC';
import { EDateType } from '../../../../../../../../const';
import { TCardId } from '../../../../../../../../types/types';

export const getCloseElement = (
    cardId: TCardId,
    type: EDateType
): JSX.Element => {
    return (<CardDatesCloseButtonHOC cardId={cardId} type={type}/>)
};
